import React from "react";
import { useSelector } from "react-redux";
import { SnackbarProvider } from "notistack";
import TotalReviewsNew from "../../Components/TotalReviewsNew";

const ReviewsAbstractPage = () => {
  const invitation = useSelector((state) => state.invitation.value);
  console.log("reducer", invitation);
  return (
    <SnackbarProvider>
      <div style={{ height: "78vh" }} className="main-wrapper">
        <div className="content-wrapper">
          <TotalReviewsNew />
        </div>
      </div>
    </SnackbarProvider>
  );
};

export default ReviewsAbstractPage;
